var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1205_22355)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.944264 0.655202C1.36378 0.235683 1.93277 0 2.52606 0H4.84156C5.1177 0 5.34156 0.223858 5.34156 0.5V4.5525C5.34156 4.82864 5.1177 5.0525 4.84156 5.0525H4.18356V5.1315C4.18356 5.92024 4.4969 6.67672 5.05463 7.23445C5.49335 7.67318 6.05507 7.96067 6.65873 8.06338L6.66006 7.44892C6.66066 7.1732 6.88434 6.95 7.16006 6.95H11.2101C11.4862 6.95 11.7101 7.17386 11.7101 7.45V9.763C11.7101 10.3563 11.4744 10.9253 11.0549 11.3448C10.6353 11.7643 10.0664 12 9.47306 12H8.34456C6.20817 11.9998 4.15928 11.1511 2.64861 9.64045C1.13795 8.12979 0.289206 6.08093 0.289062 3.94453V2.237C0.289062 1.64371 0.524745 1.07472 0.944264 0.655202ZM2.52606 1C2.19799 1 1.88335 1.13033 1.65137 1.36231C1.41939 1.59429 1.28906 1.90893 1.28906 2.237V3.94447C1.28906 3.94448 1.28906 3.94446 1.28906 3.94447C1.2892 5.81566 2.03258 7.61021 3.35572 8.93335C4.67885 10.2565 6.47337 10.9999 8.34456 11C8.34457 11 8.34455 11 8.34456 11H9.47306C9.80116 11 10.1158 10.8697 10.3478 10.6377C10.5797 10.4057 10.7101 10.0911 10.7101 9.763V7.95H7.65898L7.65756 8.60658C7.65696 8.8823 7.43328 9.1055 7.15756 9.1055C6.10361 9.1055 5.09278 8.68683 4.34752 7.94155C3.60225 7.19628 3.18356 6.18546 3.18356 5.1315V4.5525C3.18356 4.27636 3.40742 4.0525 3.68356 4.0525H4.34156V1H2.52606Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1205_22355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.a582d5c7e4e001a5bacdc63d80c7c8a6.svg";
export { ForwardRef as ReactComponent };